import { createReducer } from '@reduxjs/toolkit';
import { updateMultipleItem,
  previousSelectedItems,
  currentSelectedItems,
  currentBundleSumarry,
  removeItem,
  createNewGuid,
  updatePreviousSelectedItems } from '../actions/multipleLineItem/multipleLinePricing';

export const initial = {
  currentSelectedItem: [],
  previousSelections: [],
  updatedMultipleLineItem: [],
  currentBundleSumarry: [],
};

export const multipleLineIemPricing = createReducer(initial, (builder) => {
  builder
    .addCase(updateMultipleItem, (state, action) => ({
      ...state,
      updatedMultipleLineItem: action.payload,
    }))
    .addCase(previousSelectedItems, (state, action) => {
      const allSetelectItems = [...action.payload];
      return {
        ...state,
        previousSelections: allSetelectItems,
      };
    })
    .addCase(removeItem, (state, action) => {
      const updatedPreviousItems = state.previousSelections
        .filter(item => item.uniqueIdentifier !== action.payload);
      return {
        ...state,
        previousSelections: updatedPreviousItems,
      };
    })
    .addCase(currentSelectedItems, (state, action) => ({
      ...state,
      currentSelectedItem: action.payload,
    }))
    .addCase(currentBundleSumarry, (state, action) => ({
      ...state,
      currentBundleSumarry: action.payload,
    }))
    .addCase(createNewGuid, (state, action) => ({
      ...state,
      currentSelectedItem: [{
        ...state.currentSelectedItem[0],
        uniqueIdentifier: action.payload,
      }],
    }))
    .addCase(updatePreviousSelectedItems, (state, action) => {
      const previousNoSelectedItems = state.previousSelections
        .filter(item => item.uniqueIdentifier !== action.payload.selectedGuid);

      const previousItem = state.previousSelections
        .filter(item => item.uniqueIdentifier === action.payload.selectedGuid);

      const updatedPrevSelectedItem = previousItem.length ?
       [{ ...previousItem[0], quantity: action.payload.mergedQty }]
       : [];
      const newPreviousSelectedItems = [...previousNoSelectedItems, ...updatedPrevSelectedItem];
      return {
        ...state,
        previousSelections: newPreviousSelectedItems,
      };
    });
});
